import * as React from "react";
import { forwardRef } from "react";
import styled from "styled-components";
const Headline = styled.h3`
  margin-bottom: 15px;

  @media print {
    margin-top: 15px;

    /* This is the desired behaviour, but currently unimplemented in Chrome. It may be implemented in a future version, so we leave it here. */
    page-break-after: avoid;
    page-break-inside: avoid;
    break-after: avoid;
  }
`;
const Heading = ({ title, headerId = void 0 }, ref) => /* @__PURE__ */ React.createElement(Headline, { ref, id: headerId }, title);
export default forwardRef(Heading);
